module.exports = __webpack_public_path__ + "img/Swap-Bridge-bg-780.37dbfefb.png";